import { render } from "./merchantAdd.vue?vue&type=template&id=5232d0da"
import script from "./merchantAdd.vue?vue&type=script&lang=js"
export * from "./merchantAdd.vue?vue&type=script&lang=js"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__